/*
  fw-reveal — entrance reveal observer
  ------------------------------------
  Adds .fw-in to [data-fw-reveal] elements when they scroll into view, so the
  CSS transition (see fw-reveal.css) plays once. Reveal-once (unobserve after).

  - No-ops under prefers-reduced-motion (the head script never adds
    `fw-reveal-ready`, so elements are never hidden — nothing to reveal).
  - Re-scans on `shopify:section:load` so reveals work in the theme editor.
  - Idempotent: guarded so loading twice does nothing.
*/
(function () {
  if (window.__fwRevealInit) return;
  window.__fwRevealInit = true;

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reduced motion or no observer support: reveal everything immediately.
  if (reduce || typeof IntersectionObserver === 'undefined') {
    var showAll = function () {
      var els = document.querySelectorAll('[data-fw-reveal]');
      for (var i = 0; i < els.length; i++) els[i].classList.add('fw-in');
    };
    if (document.readyState !== 'loading') showAll();
    else document.addEventListener('DOMContentLoaded', showAll);
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fw-in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0, rootMargin: '0px 0px -12% 0px' }
  );

  function observe(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('[data-fw-reveal]:not(.fw-in)');
    for (var i = 0; i < els.length; i++) io.observe(els[i]);
  }

  /*
    Safety net for elements flush with the end of the document.

    The -12% bottom rootMargin above means an element only counts as visible
    once it is 12% of the viewport clear of the bottom edge. Anything sitting
    at the very end of the page can never get there — you run out of scroll
    first — so it would stay at opacity 0 permanently. That is what hid the
    footer wordmark: last element, no padding below it, and short enough on a
    phone to live entirely inside the dead zone.

    Once the viewport reaches the bottom of the document, reveal whatever is
    still waiting. rAF-throttled, and the DOM is only queried at the bottom.
  */
  var endTicking = false;

  function revealAtDocumentEnd() {
    endTicking = false;
    if (window.innerHeight + window.pageYOffset < document.documentElement.scrollHeight - 2) return;

    var els = document.querySelectorAll('[data-fw-reveal]:not(.fw-in)');
    for (var i = 0; i < els.length; i++) {
      els[i].classList.add('fw-in');
      io.unobserve(els[i]);
    }
  }

  function onEndScroll() {
    if (endTicking) return;
    endTicking = true;
    requestAnimationFrame(revealAtDocumentEnd);
  }

  window.addEventListener('scroll', onEndScroll, { passive: true });
  window.addEventListener('resize', onEndScroll);

  function init() {
    observe(document);
    // Covers pages short enough that they never scroll.
    revealAtDocumentEnd();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Theme editor: a re-rendered section's elements need (re)observing.
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
    revealAtDocumentEnd();
  });
})();
